export const ROWS_BAR_WIDTH = 64;
export const COLS_BAR_HEIGHT = 24;
export const VISIBLE_MARGIN = 100;
export const SCROLL_MARGIN_X = 100;
export const SCROLL_MARGIN_Y = 37.5;
